import { render } from "./TicketForm.vue?vue&type=template&id=9852b4d6&scoped=true"
import script from "./TicketForm.vue?vue&type=script&lang=js"
export * from "./TicketForm.vue?vue&type=script&lang=js"

import "./TicketForm.vue?vue&type=style&index=0&id=9852b4d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9852b4d6"]])

export default __exports__